import React from 'react'
import VisibilitySensor from '@jarvis.oddle/core/components/VisibilitySensor'

interface CategoryLoaderProps {
  children: React.ReactNode
  categoryId: string
  showCategoryDetails: (categoryId: string) => void
  disabled: boolean
}

const CategoryLoader = ({
  children,
  categoryId,
  showCategoryDetails,
  disabled
}: CategoryLoaderProps): JSX.Element => {
  const onVisibilityChange = React.useCallback(
    (isVisible) => {
      if (isVisible) {
        showCategoryDetails(categoryId)
      }
    },
    [categoryId, showCategoryDetails]
  )

  return (
    <VisibilitySensor
      rootMargin='-200px 0px 700px 0px'
      onChange={onVisibilityChange}
      disabled={disabled}
    >
      {children}
    </VisibilitySensor>
  )
}

export default CategoryLoader
